import { QueryClient, QueryClientProvider } from 'react-query';
import { createRoot } from '@wordpress/element';
import { registerPlugin } from '@wordpress/plugins';
import { App } from './App';
import './styles/output.css';
import MenuLateralAnalises from './pages/MenuLateral/MenuLateralAnalises';

registerPlugin('opti-sidebar', { render: () => <MenuLateralAnalises /> });

const container = document.getElementById('optimarketing');
const queryClient = new QueryClient();

if (container) {
  createRoot(container).render(
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  );
}
